var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColoredArrow = function SvgColoredArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 124,
    viewBox: "0 0 108 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "colored_arrow_svg__mask0_31535_36135",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 16,
    width: 91,
    height: 83
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.7472 17.3636C84.2649 17.8766 85.8552 18.4904 87.3952 19.1404C89.2314 19.883 87.9735 22.7029 86.0365 22.0329C84.7062 21.4613 83.3618 20.9764 82.0175 20.4915C81.6017 20.3617 81.1629 20.239 80.7231 20.1175C81.8753 21.3049 82.9672 22.5597 83.924 23.9008C89.2493 31.2056 92.0654 40.4098 91.4424 49.439C90.8199 58.8303 86.4277 67.6319 79.5933 74.1062C73.3852 79.955 65.4071 83.65 56.9542 84.3169C49.9992 91.0451 41.0568 95.7736 31.4804 97.4951C21.5718 99.3116 11.3383 98.0412 2.12212 93.9797C1.39753 93.619 1.20393 92.4908 1.5328 91.8195C2.0105 91.0202 2.90472 90.9761 3.66115 91.2835C5.6536 92.185 7.77342 92.8733 9.87182 93.4765C18.8191 95.9308 28.4112 95.7331 37.1787 92.8007C42.6363 90.9797 47.7724 88.0869 52.2157 84.375C43.3544 83.9171 34.6338 80.3749 28.0652 74.4089C24.365 71.0405 20.9613 66.6921 21.1649 61.3898C21.3374 56.5028 23.9274 52.0481 26.9871 48.3804C33.0111 41.2048 42.6171 36.7485 52.0316 38.542C56.5046 39.4072 60.7352 41.6462 63.9453 44.8665C67.2835 48.2355 69.2076 52.6398 69.5778 57.3449C70.2264 65.8986 65.858 74.2245 60.3682 80.6735C60.6308 80.6241 60.8929 80.5715 61.1543 80.5155C69.5299 78.723 77.0693 73.6102 82.0184 66.6601C87.0208 59.7418 89.2418 51.306 88.2369 42.8226C87.294 34.8966 83.6595 27.2656 77.938 21.6751C77.8732 21.8944 77.8117 22.1142 77.7604 22.3357C77.4125 23.6578 77.1009 25.0303 76.876 26.4169C76.5527 28.4101 73.5196 27.918 73.8429 25.9249C74.1604 24.242 74.5142 22.6095 75.005 20.9548C75.0801 20.7014 75.151 20.4296 75.224 20.1492C75.6282 18.5985 76.1008 16.7854 77.7491 16.3749C78.5853 16.1548 79.4015 16.3317 80.2037 16.5952L80.2038 16.5952C81.0563 16.8225 81.9088 17.0497 82.7472 17.3636ZM55.6364 81.2143C57.067 79.7524 58.3984 78.1965 59.6143 76.5577C64.564 69.9696 68.6892 60.6468 65.3532 52.4336C62.2524 44.7949 53.6425 40.4449 45.6166 41.2893C37.1969 42.1876 29.4462 48.259 25.7864 55.8349C24.8635 57.7423 24.2922 59.7874 24.2745 61.8741C24.2998 64.1311 25.2296 66.2055 26.5104 68.0558C29.0077 71.5008 32.5792 74.3585 36.2879 76.5026C42.1223 79.8195 48.9335 81.5019 55.6364 81.2143Z",
    fill: "#32302F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#colored_arrow_svg__mask0_31535_36135)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#colored_arrow_svg__filter0_f_31535_36135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-60.3016 206.709C-42.3466 215.492 -24.2668 224.106 -6.37421 232.974C10.7104 241.336 20.4697 233.316 42.4492 202.748C92.9337 132.375 145.135 62.7165 196.857 -7.17359C205.785 -19.2658 207.979 -31.5122 201.756 -34.5167C157.496 -55.8846 113.192 -77.2734 69.0567 -98.8104L-60.3016 206.709Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colored_arrow_svg__filter1_f_31535_36135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5607 114.708C28.2879 138.145 37.9964 161.591 47.7235 185.054C45.0345 163.236 40.6621 139.964 35.6764 117.103C31.1938 96.5766 26.1812 75.4629 25.0093 57.0415C24.0155 41.4756 25.7843 28.9299 28.6973 17.6547C26.0538 -5.99969 26.8608 -26.545 31.4347 -43.6171C34.8581 -56.378 39.7563 -50.3314 46.623 -56.4296C49.1365 -37.1428 58.9889 -53.6769 56.9812 -72.8419C56.1589 -80.691 54.9152 -77.8246 54.9858 -84.9035C55.0482 -89.8432 51.0962 -97.114 52.0144 -101.026C56.2439 -118.85 41.9964 -161.254 47.8353 -176.763C31.4252 -181.105 40.1605 -122.276 28.2747 -114.733C33.1235 -69.922 23.4178 -67.4814 16.3608 -35.0578C15.7766 -32.3909 7.21464 -28.6333 6.56529 -26.0438L-0.110371 72.4105C2.35685 79.3548 15.7589 107.942 18.5607 114.708Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colored_arrow_svg__filter2_f_31535_36135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6141 62.3864C45.425 33.4464 29.3835 -11.2046 7.53177 -25.2182C-9.58183 -4.76771 30.3866 1.00266 13.273 21.4531L28.3342 64.2984C40.0264 72.387 37.7245 80.1792 52.6141 62.3864Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colored_arrow_svg__filter3_f_31535_36135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6412 233.587C74.3743 234.588 75.4724 234.775 76.2451 235.814C77.0179 236.852 78.992 239.751 79.6489 239.682C80.5983 239.582 81.9639 240.629 82.9344 238.722C83.8724 236.88 83.9532 233.882 84.1569 231.694C84.9049 223.663 84.5615 215.572 84.771 207.644C84.8769 203.634 85.6514 199.576 85.8924 195.497C86.0099 193.509 85.5642 192.449 85.9976 190.302C86.4138 188.24 86.4415 186.206 86.5626 184.156C86.8558 179.194 88.1177 174.818 89.2204 169.914C90.4376 164.501 90.4454 156.948 90.4121 151.645C90.3056 134.7 84.7037 122.55 81.2702 108.284C79.9383 102.75 77.8673 98.024 76.888 92.1363C75.8564 85.9347 76.21 79.3256 76.6113 72.5344C77.2957 60.953 78.2895 48.1866 77.3102 37.1846C76.8563 32.0861 76.0114 27.5424 73.8212 24.1339C71.4605 20.4601 65.2509 22.2611 62.1021 25.9008C60.3538 27.9218 58.6702 33.4183 57.757 36.4444C56.7885 39.654 56.0452 42.93 55.3407 46.2191C52.7107 58.4997 52.7117 71.4081 54.0126 82.733C55.6457 96.9501 52.3706 110.228 50.9311 125.012C50.2406 132.105 50.1761 139.056 50.0751 145.948C50.0082 150.516 52.2064 154.486 53.2074 158.205C56.02 168.654 61.4547 175.54 62.7852 187.36C63.4029 192.848 63.8561 198.598 63.5665 204.493C63.4091 207.698 63.0974 212.501 63.9407 215.236C65.5081 220.321 67.0037 226.746 70.1574 229.555C71.3075 230.579 72.6623 232.251 73.6412 233.587Z",
    fill: "#71BBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colored_arrow_svg__filter0_f_31535_36135",
    x: -64.3016,
    y: -102.81,
    width: 273.598,
    height: 342.89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31535_36135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colored_arrow_svg__filter1_f_31535_36135",
    x: -4.11038,
    y: -180.992,
    width: 65.3595,
    height: 370.046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31535_36135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colored_arrow_svg__filter2_f_31535_36135",
    x: -0.82843,
    y: -29.2181,
    width: 57.4425,
    height: 106.387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31535_36135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colored_arrow_svg__filter3_f_31535_36135",
    x: 46.0736,
    y: 18.1176,
    width: 48.3469,
    height: 225.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_31535_36135"
  })))));
};
export default SvgColoredArrow;